"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var d3_1 = require("d3");
function getLabelMaxWidth(nodes) {
    var e_1, _a;
    var max = 0;
    try {
        for (var nodes_1 = tslib_1.__values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
            var node = nodes_1_1.value;
            if (node) {
                var width = node.getBoundingClientRect().width;
                if (max < width)
                    max = width;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return Math.round(max);
}
exports.getLabelMaxWidth = getLabelMaxWidth;
function getLabelMinWidth(nodes) {
    var e_2, _a;
    var min = 0;
    try {
        for (var nodes_2 = tslib_1.__values(nodes), nodes_2_1 = nodes_2.next(); !nodes_2_1.done; nodes_2_1 = nodes_2.next()) {
            var node = nodes_2_1.value;
            if (node) {
                var width = node.getBoundingClientRect().width;
                if (min > width)
                    min = width;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (nodes_2_1 && !nodes_2_1.done && (_a = nodes_2.return)) _a.call(nodes_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return Math.floor(min);
}
exports.getLabelMinWidth = getLabelMinWidth;
function getLabelMaxHeight(nodes) {
    var e_3, _a;
    var max = 0;
    try {
        for (var nodes_3 = tslib_1.__values(nodes), nodes_3_1 = nodes_3.next(); !nodes_3_1.done; nodes_3_1 = nodes_3.next()) {
            var node = nodes_3_1.value;
            if (node) {
                var height = node.getBoundingClientRect().height;
                if (max < height)
                    max = height;
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (nodes_3_1 && !nodes_3_1.done && (_a = nodes_3.return)) _a.call(nodes_3);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return Math.round(max);
}
exports.getLabelMaxHeight = getLabelMaxHeight;
function nodeWidth(node) {
    // firefox 环境下 getBBox 方法会报错
    try {
        return node.getBBox().width;
    }
    catch (e) {
        return 0;
    }
}
exports.nodeWidth = nodeWidth;
function nodeHeight(node) {
    // firefox 环境下 getBBox 方法会报错
    try {
        return node.getBBox().height;
    }
    catch (e) {
        return 0;
    }
}
exports.nodeHeight = nodeHeight;
function textSize(text, style) {
    var t = d3_1.select("body").append("span");
    var textNode = t
        .text(text)
        .attr("style", style)
        .node();
    if (textNode) {
        var _a = textNode.getBoundingClientRect(), width = _a.width, height = _a.height;
        t.remove();
        return { width: Math.round(width), height: Math.round(height) };
    }
    return { width: 0, height: 0 };
}
exports.textSize = textSize;
function textWrap(text, invert, barWidth) {
    text.each(function wrap(data) {
        var width = invert ? data.metric : barWidth;
        var text = d3_1.select(this);
        var words = text
            .text()
            .split("")
            .reverse();
        var word = words.pop();
        var line = [];
        var lineNumber = 0;
        var lineHeight = 1.3; // ems
        var y = text.attr("y");
        var wrapTSpan = text
            .text(null)
            .append("tspan")
            .attr("x", 0)
            .attr("y", y)
            .attr("fill", "#fff")
            .attr("stroke", "#fff")
            .attr("stroke-width", "2px")
            .attr("stroke-linejoin", "round");
        var tspan = text
            .append("tspan")
            .attr("x", 0)
            .attr("y", y);
        while (word) {
            if (word === "\n") {
                lineNumber += 1;
                line = [];
                tspan = text
                    .append("tspan")
                    .attr("x", 0)
                    .attr("y", y)
                    .attr("dy", lineNumber * lineHeight + "em")
                    .text("");
            }
            else {
                line.push(word);
                tspan.text(line.join(""));
                wrapTSpan.text(line.join(""));
                var node = tspan.node();
                var nodeExist = document.body.contains(node);
                if (nodeExist && node.getComputedTextLength() > width) {
                    lineNumber += 1;
                    line.pop();
                    tspan.text(line.join(""));
                    line = [word];
                    wrapTSpan = text
                        .append("tspan")
                        .attr("x", 0)
                        .attr("y", y)
                        .attr("dy", lineNumber * lineHeight + "em")
                        .attr("fill", "#fff")
                        .attr("stroke", "#fff")
                        .attr("stroke-width", "2px")
                        .attr("stroke-linejoin", "round")
                        .text(word);
                    tspan = text
                        .append("tspan")
                        .attr("x", 0)
                        .attr("y", y)
                        .attr("dy", lineNumber * lineHeight + "em")
                        .text(word);
                }
            }
            word = words.pop();
        }
    });
}
exports.textWrap = textWrap;
function findTextColor(colorValue) {
    // #123456或者rgb(12,34,56)转为rgb数组[12,34,56]
    var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    var that = colorValue;
    if (/^(rgb|RGB)/.test(that)) {
        // 处理rgb转为数组
        var aColor = that
            .replace(/(?:\(|\)|rgb|RGB)*/g, "")
            .split(",")
            .map(function (i) { return Number(i); });
        return resBgColor(aColor);
    }
    if (reg.test(that)) {
        // 处理十六进制色值
        var sColor = colorValue.toLowerCase();
        if (sColor && reg.test(sColor)) {
            if (sColor.length === 4) {
                var sColorNew = "#";
                for (var i = 1; i < 4; i += 1) {
                    sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
                }
                sColor = sColorNew;
            }
            // 处理六位的颜色值
            var sColorChange = [];
            for (var i = 1; i < 7; i += 2) {
                sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2), 16));
            }
            return resBgColor(sColorChange);
        }
        return false;
    }
    return false;
}
exports.findTextColor = findTextColor;
/**
 * 转换字体颜色
 *
 * @param {array} rgbArr rgb数组
 */
function resBgColor(rgbArr) {
    // 当color值大于128时,color值偏向255,即#ffffff,此时字体颜色应为#000000
    // 当color值小于128时,color值偏向0,即#000000,此时字体颜色应为#ffffff
    var color = 0.213 * rgbArr[0] + 0.715 * rgbArr[1] + 0.072 * rgbArr[2] > 255 / 2;
    return color ? "#000000" : "#ffffff";
}
exports.resBgColor = resBgColor;
//# sourceMappingURL=svg-helper.js.map